import Swiper from "swiper/bundle";
import Contacts from "./template-contacts";

const About = {
  init() {
    About.history();
    Contacts.renderMap();
    About.employeeHeight();
  },

  employeeHeight() {
    const blocks = $(".contact-item__top");
    const heights = [];
    blocks.each((id, item) => {
      heights.push(item.offsetHeight);
    });
    const maxHeight = Math.max(...heights);
    blocks.css({ height: maxHeight + "px" });
  },

  history() {
    const historyEl = $(".history");

    const slider = new Swiper($(".history-slider")[0], {
      // modules: [Navigation, Lazy],
      loop: false,
      spaceBetween: 240,
      autoHeight: false,

      navigation: {
        prevEl: historyEl.find(".swiper-button-prev")[0],
        nextEl: historyEl.find(".swiper-button-next")[0],
      },
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 1,
      },
      breakpoints: {
        0: {
          autoHeight: true,
        },
        900: {
          autoHeight: false,
        }
      }
    });

    slider.on("resize", () => {
      const image = historyEl.find(".history-slide__img")[0];
      const year = historyEl.find(".history-slide__year")[0];

      if ($(window).innerWidth() >= 1200) {
        historyEl
          .find(".swiper-nav")
          .css({ top: `${$(image).innerHeight() + 20}px` });
      } else {
        historyEl.find(".swiper-nav").css({
          top: `${$(image).innerHeight() + $(year).innerHeight() + 20 + 20}px`,
        });
      }
    });
  },
};

export default About;
